<template>
  <byted-input
    slot="input"
    size="md"
    class="search-input"
    @keyup.enter="inputEnterHandler"
    v-model="innerValue.value"
    :placeholder="$bp_t(placeHolder, 'common.please_input')"
    style="width: 210px"
  >
    <template slot="prepend">
      <!-- 筛选项只有一项不展示下拉框, 改为button组件 -->
      <byted-button v-if="Object.keys(prependOptionList).length === 1" class="fixed-button">{{ prependOptionList[Object.keys(prependOptionList)[0]].text }}</byted-button>
      <byted-select v-else :class="'type-select' + length" v-model="innerValue.option">
        <byted-option
          v-for="option in prependOptionList"
          :key="option.value"
          :value="option.value"
        >{{ option.text }}</byted-option>
      </byted-select>
    </template>
    <template slot="append">
      <byted-button @click="searchBtnClickHandler" class="search-btn" size="md">
        <byted-icon name="search" class="search-icon"></byted-icon>
      </byted-button>
    </template>
  </byted-input>
</template>

<script>
export default {
  name: 'prepend-search',
  props: {
    value: {
      type: Object,
      default: () => ({
        value: '',
        option: ''
      })
    },
    prependOptionList: {
      type: Object,
      default: () => {}
    },
    placeHolder: {
      type: String,
      default: '请输入'
    },
    // 前置筛选框尺寸， 目前支持md和lg 有需要下面函数加
    prependSize: {
      type: String,
      default: 'md'
    }
  },
  data () {
    return {
      innerValue: {
        value: '',
        option: Object.keys(this.prependOptionList)[0]
      },
      length: ' shorter',
      isSingleList: this.getIsSingleList()
    }
  },
  created () {
    this.handleLengthClass()
  },
  methods: {
    inputEnterHandler () {
      this.searchBtnClickHandler()
    },
    searchBtnClickHandler () {
      // 如果为单条list 不会出现选择, 这里会自动取出单条的value发送
      if (this.isSingleList) {
        this.innerValue.option = this.prependOptionList[Object.keys(this.prependOptionList)[0]].value
      }
      if (this.innerValue.value === '') return
      this.$emit('valueChanged', { ...this.innerValue })
      this.innerValue.value = ''
    },
    getIsSingleList () {
      return Object.keys(this.prependOptionList).length === 1
    },
    handleLengthClass () {
      switch (this.prependSize) {
        case 'md':
          break
        case 'lg':
          this.length = ' longger'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input ::placeholder {
  color: #c1c1c1;
}
.fixed-button {
  background: #fff;
  width: 80px;
  padding: 5px 0px;
  min-width: 80px;

  &:hover {
    color: #333 ;
    background: #fff;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(51,138,255,.2);
    background: #fff;
    color: #333;
  }
}

.type-select {
  width: 75px;
  &.longger {
    width: 98px;
  }

  /deep/ .bui-select-wrapper {
    .bui-input {
      padding: 5px 12px 5px 12px;
      padding-left: 12px !important;
    }
  }
}

.search-btn {
  min-width: 20px;
  padding: 5px 8px;

  .search-icon {
    margin-bottom: 4px;
  }
}
</style>
